import { http } from '@/services/http'

export default {
  getTags() {
    return http.get('/tags')
  },
  updateTag({ name, id }) {
    return http.put(`/tags/${id}`, { name })
  },
  deleteTag({ id }) {
    return http.delete(`/tags/${id}`)
  },
  createTag({ name }) {
    return http.post('/tags', { name })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/tag.js